export default __webpack_public_path__ + "static/1068-9ab587f02c2a6328b7d4a59be0467ad8.gif";